import React, { useCallback, useEffect, useContext, useState, useMemo } from 'react'
import { MainButton } from '../../../Button/MainButton'
import { Dialog, DialogTitle, DialogContent, makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../../utils'
import DaycareWizardContext from '../DaycareWizardContext'
import PetAvatar from '../../../Common/PetAvatar'
import { FOOD_SCHEDULE_OPTIONS } from '../constants'
import CheckboxMenu from '../../../Common/Menus/CheckboxMenu'

const useStyles = makeStyles(() => ({
	content: { display: 'flex', flexDirection: 'column', gap: '1.4rem' },
	header: {
		marginBottom: '.8rem'
	},
	titleText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem',
		textTransform: 'uppercase'
	},
	checkboxMenuContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '.5rem'
	},
	actionsContainer: {
		justifyContent: 'flex-start',
		marginTop: '1rem',
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		marginTop: '4rem'
	},
	mainActions: {
		display: 'flex',
		flexDirection: 'row',
		alignSelf: 'flex-start',
		gap: '1rem',
		'& .MuiButton-outlinedSizeLarge': {
			height: 'unset'
		}
	},
	sectionHeader: {
		fontFamily: 'Nunito',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '0.75rem',
		textTransform: 'uppercase',
		letterSpacing: '0.047rem'
	}
}))

const EditMealAddOnsDialog = ({
	open,
	onSave,
	onCancel,
	title = 'Edit Food Schedule',
	values: { pet_id = '', name = '', image_url = '', meals = [], exceptions = [] }
}) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { wizard_state }
	} = useContext(DaycareWizardContext)

	const [editedMealAddons, setEditedMealAddons] = useState([])
	const [editedExceptions, setEditedExceptions] = useState([])

	useEffect(() => {
		setEditedMealAddons([...meals])
	}, [meals])

	const foodScheduleOptions = useMemo(() => {
		const options = FOOD_SCHEDULE_OPTIONS.map((option) => {
			const { title, time, disabledWhen = {} } = option
			let disabled = false

			for (const checkAttr in disabledWhen) {
				if (wizard_state[checkAttr] === disabledWhen[checkAttr]) {
					disabled = true
				}
			}
			return { label: title, value: time, disabled }
		})
		return options
	}, [wizard_state])

	const handleEditedMealAddonsChanged = useCallback(
		(newAddons) => {
			setEditedMealAddons(newAddons)
		},
		[setEditedMealAddons]
	)

	const handleOnSave = useCallback(() => {
		if (onSave) {
			onSave({ pet_id, meals: editedMealAddons, exceptions: editedExceptions })
			setEditedMealAddons([])
		}
	}, [onSave, editedMealAddons, editedExceptions, pet_id, setEditedMealAddons])

	const handleOnCancel = useCallback(() => {
		if (onCancel) {
			onCancel()
		}
	}, [onCancel])

	return (
		<Dialog
			PaperProps={{
				style: {
					width: 450,
					maxWidth: 450,
					minWidth: 450
				}
			}}
			maxWidth="md"
			open={open}
			onClose={() => null}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.titleText}>{title}</div>
				</div>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<div>Choose the times this dog receives their daily meals.</div>
				<div style={{ margin: '0 0.09rem' }}>
					<PetAvatar petName={name} imageUrl={image_url} />
				</div>
				<div className={classes.checkboxMenuContainer}>
					<div className={classes.sectionHeader}>Timeblock</div>
					<CheckboxMenu
						selectedOptions={meals}
						options={foodScheduleOptions}
						onSelectedChanged={handleEditedMealAddonsChanged}
					/>
				</div>
			</DialogContent>
			<div className={classes.actionsContainer}>
				<div className={classes.mainActions}>
					<MainButton
						style={{ paddingTop: '6px' }}
						variant="contained"
						label="Save"
						onClick={handleOnSave}
					/>
					<MainButton label="Cancel" onClick={handleOnCancel} />
				</div>
			</div>
		</Dialog>
	)
}

export default EditMealAddOnsDialog
